module.exports = __webpack_public_path__ + "static/img/dpBanner.6912097a.png";